let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dHj1E")).then(() => parcelRequire('17rJq'));